import { Injectable } from '@angular/core';
import * as moment from 'moment';

import { AttributeModel } from '../../models/AttributeModel';
import { ISearchParameters } from '../../pages/page-components/Parameters/search-parameters/searchParameters';
import { EnvironmentVariablesService } from '../environment-variables.service';
import { UserService } from '../user/user.service';
import { AuditService } from './audit.service';

@Injectable({
  providedIn: 'root',
})
export class AuditLogService {
  userName: string;
  userRole: string;
  emailAddress: string;

  constructor(
    user: UserService,
    public audit: AuditService,
    public ev: EnvironmentVariablesService,
  ) {
    user.userName.subscribe(v => {
      this.userName = v;
    });
    user.emailAddress.subscribe(v => {
      this.emailAddress = v;
    });
    user.roles.subscribe(v => {
      this.userRole = v[0];
    });
  }

  private utcDateTime(): Date {
    let utcDateTime = moment(new Date().toUTCString()).toDate();
    return utcDateTime;
  }

  public exportEvent(pageName: string, exportType: string): void {
    switch (pageName) {
      case 'ODSearch': {
        this.audit.LogAuditMessage({
          UserName: this.userName,
          UserRole: this.userRole,
          EventName: 'Search Export Clicked',
          UserEmail: this.emailAddress,
          PageName: pageName,
          Event_DateTime: this.utcDateTime(),
          Attributes: [{ Key: 'exportType', Value: exportType }],
        });
        break;
      }
      case 'LIU': {
        this.audit.LogAuditMessage({
          UserName: this.userName,
          UserRole: this.userRole,
          EventName: 'LIU Export Clicked',
          UserEmail: this.emailAddress,
          PageName: pageName,
          Event_DateTime: this.utcDateTime(),
          Attributes: [{ Key: 'exportType', Value: exportType }],
        });
        break;
      }
      default: {
        break;
      }
    }
  }

  public downloadEvent(exportType: string): void {
    this.audit.LogAuditMessage({
      UserName: this.userName,
      UserRole: this.userRole,
      EventName: 'Search Download Clicked',
      UserEmail: this.emailAddress,
      PageName: 'ODSearch',
      Event_DateTime: this.utcDateTime(),
      Attributes: [{ Key: 'exportType', Value: exportType }],
    });
  }

  public cccPullCrossesEvent(parameters: any): void {
    this.audit.LogAuditMessage({
      UserName: this.userName,
      UserRole: this.userRole,
      EventName: 'CCC PullCrosses Started',
      UserEmail: this.emailAddress,
      PageName: 'Reports',
      Event_DateTime: this.utcDateTime(),
      Attributes: this.AddReportAttributes(parameters),
    });
  }
  private AddReportAttributes(parameters: any): AttributeModel[] {
    const attibutes: AttributeModel[] = [];
    if (
      parameters.selectedUnspscCode !== null &&
      parameters.selectedUnspscCode.length > 0
    ) {
      attibutes.push({ Key: 'isUnspscSelected', Value: 'true' });
    }
    if (
      parameters.selectedPSCDescription !== null &&
      parameters.selectedPSCDescription.length > 0
    ) {
      attibutes.push({ Key: 'isPscSelected', Value: 'true' });
    }
    if (parameters.includeAttributedCrosses) {
      attibutes.push({ Key: 'isAttributionSelected', Value: 'true' });
    }
    if (parameters.includeDerivedCrosses) {
      attibutes.push({ Key: 'isDerivationSelected', Value: 'true' });
    }
    if (parameters.sameVendorSet) {
      attibutes.push({ Key: 'isSameVendorSelected', Value: 'true' });
    }
    return attibutes;
  }

  public searchEvent(
    parameters: {},
    time: string,
    recordCount: number,
    status: string,
  ) {
    let attributes = this.AddSearchAttributes(parameters);
    attributes.push({ Key: 'searchDuration', Value: time });
    attributes.push({ Key: 'searchRecordCount', Value: '' + recordCount });
    attributes.push({ Key: 'searchStatus', Value: status });

    this.audit.LogAuditMessage({
      UserName: this.userName,
      UserRole: this.userRole,
      EventName: 'Search Started',
      UserEmail: this.emailAddress,
      PageName: 'ODSearch',
      Event_DateTime: this.utcDateTime(),
      Attributes: attributes,
    });
  }

  public uploadEvent(): void {
    this.audit.LogAuditMessage({
      UserName: this.userName,
      UserRole: this.userRole,
      EventName: 'LIU Upload Started',
      UserEmail: this.emailAddress,
      PageName: 'LIU',
      Event_DateTime: this.utcDateTime(),
      Attributes: [],
    });
  }

  public tabClickEvent(tabName: string): void {
    this.audit.LogAuditMessage({
      UserName: this.userName,
      UserRole: this.userRole,
      EventName: 'Nav Menu Clicked',
      UserEmail: this.emailAddress,
      PageName: 'XrefAPP',
      Event_DateTime: this.utcDateTime(),
      Attributes: [{ Key: 'tabName', Value: tabName }],
    });
  }

  //private AddSearchAttributes(searchParameters, list: SearchCriteria[]): AttributeModel[] {
  //  const attibutes: AttributeModel[] = [];
  //  attibutes.push({ Key: 'numberOfParameters', Value: '' + Object.keys(searchParameters).length });
  //  list.forEach(r => {
  //    if (searchParameters[r.searchCategory] !== null)
  //      attibutes.push({ Key: 'searchParameter', Value: r.searchCategory  });
  //  });
  //  if (searchParameters.fileBatch != null)
  //    attibutes.push({ Key: "batch", Value: searchParameters.fileBatch });

  //  return attibutes;
  //}

  private AddSearchAttributes(
    searchParameters: ISearchParameters,
  ): AttributeModel[] {
    const attributes: AttributeModel[] = [];
    //let i = 0;
    let numberofparameters = 0;

    if (searchParameters.VendorNames.length > 0) {
      attributes.push({ Key: 'searchParameter', Value: 'VendorName' });
      attributes.push({
        Key: 'searchParameterCount',
        Value:
          'VendorNamesCount:' + searchParameters.VendorNames.split(',').length,
      });
      numberofparameters = numberofparameters + 1;
    }
    if (searchParameters.ProductKeys.length > 0) {
      attributes.push({ Key: 'searchParameter', Value: 'ProductKey' });
      attributes.push({
        Key: 'searchParameterCount',
        Value:
          'ProductKeysCount:' + searchParameters.ProductKeys.split(',').length,
      });
      numberofparameters = numberofparameters + 1;
    }
    if (searchParameters.ContractNumbers.length > 0) {
      attributes.push({ Key: 'searchParameter', Value: 'ContractNumber' });
      attributes.push({
        Key: 'searchParameterCount',
        Value:
          'ContractNumbersCount:' +
          searchParameters.ContractNumbers.split(',').length,
      });
      numberofparameters = numberofparameters + 1;
    }
    if (searchParameters.VendorPartNumbers.length > 0) {
      attributes.push({ Key: 'searchParameter', Value: 'VendorPartNumbers' });
      attributes.push({
        Key: 'searchParameterCount',
        Value:
          'VendorPartNumbersCount:' +
          searchParameters.VendorPartNumbers.split(',').length,
      });
      numberofparameters = numberofparameters + 1;
    }
    //if (searchParameters.BatchIds != null)
    //  attibutes.push({ Key: "batch", Value: searchParameters.BatchIds });
    if (searchParameters.ConfidenceLabels.length > 0) {
      attributes.push({ Key: 'searchParameter', Value: 'ConfidenceLabel' });
      numberofparameters = numberofparameters + 1;
    }
    if (searchParameters.VendorProductDescriptions.length > 0) {
      attributes.push({
        Key: 'searchParameter',
        Value: 'VendorProductDescription',
      });
      numberofparameters = numberofparameters + 1;
    }
    if (searchParameters.UnspscCodes.length > 0) {
      attributes.push({ Key: 'searchParameter', Value: 'UNSPSCCodes' });
      numberofparameters = numberofparameters + 1;
    }
    if (searchParameters.ProductSpendCatergories.length > 0) {
      attributes.push({
        Key: 'searchParameter',
        Value: 'ProductSpendCatergories',
      });
      numberofparameters = numberofparameters + 1;
    }
    if (searchParameters.BatchIds.length > 0) {
      attributes.push({ Key: 'searchParameter', Value: 'BatchId' });
      numberofparameters = numberofparameters + 1;
    }
    if (searchParameters.Sources.length > 0) {
      attributes.push({ Key: 'searchParameter', Value: 'Source' });
      numberofparameters = numberofparameters + 1;
    }
    if (searchParameters.SyncGroupDescriptions.length > 0) {
      attributes.push({
        Key: 'searchParameter',
        Value: 'SyncGroupDescription',
      });
      numberofparameters = numberofparameters + 1;
    }
    if (searchParameters.SyncSubcategoryDescriptions.length > 0) {
      attributes.push({
        Key: 'searchParameter',
        Value: 'SyncSubcategoryDescription',
      });
      numberofparameters = numberofparameters + 1;
    }
    attributes.push({
      Key: 'numberOfParameters',
      Value: '' + numberofparameters,
    });
    return attributes;
  }
}
